import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksExpenseFields', {
    expensePayeeFieldTitle: 'Payee',
    expensePaymentAccountFieldTitle: 'Payment account',
    expensePaymentTypeFieldTitle: 'Payment type',
    expensePaymentMethodFieldTitle: 'Payment method',
    expenseDateFieldTitle: 'Payment date',
    expenseNumberFieldTitle: 'Ref no.',
});
